module.exports = __webpack_public_path__ + "img/111.fd896460.png";